const OPTIONS = [
  {
    name: "systemAlerts",
    title: "System alerts",
    detail: "Purchase orders, invoices, and payment activity.",
    icon: "bi-lightning-charge",
  },
  {
    name: "marketing",
    title: "Product updates",
    detail: "Promotions, releases, and feature announcements.",
    icon: "bi-megaphone",
  },
];

const NotificationsCard = ({ notifications, setNotifications, onSaved }) => {
  const toggle = (name) => {
    setNotifications({
      ...notifications,
      [name]: !notifications[name],
    });
  };

  const handleSave = () => {
    onSaved?.({
      title: "Notifications updated",
      message: "Your alert preferences were saved successfully.",
    });
  };

  return (
    <div className="settings-form">
      <div className="settings-toggle-list">
        {OPTIONS.map((option) => {
          const enabled = Boolean(notifications[option.name]);
          return (
            <button
              key={option.name}
              type="button"
              className={`settings-toggle${enabled ? " is-on" : ""}`}
              onClick={() => toggle(option.name)}
              aria-pressed={enabled}
            >
              <span className="settings-toggle__icon">
                <i className={`bi ${option.icon}`} />
              </span>
              <span className="settings-toggle__copy">
                <strong>{option.title}</strong>
                <small>{option.detail}</small>
              </span>
              <span className="settings-switch" aria-hidden="true">
                <span />
              </span>
            </button>
          );
        })}
      </div>

      <div className="settings-actions">
        <button type="button" className="settings-btn settings-btn--primary" onClick={handleSave}>
          Save notifications
        </button>
      </div>
    </div>
  );
};

export default NotificationsCard;
